<template>
  <div>
    <div
      v-for="(item, idx) in data"
      :key="`${idx}-${item.contractId}-${item.hasAdjustment}`"
    >
      <custom-callout
        :ref="'detail-ref-' + idx"
        :border-color-hex="getColor(item)"
        :class="{ 'has-adjustment': item.hasAdjustment }"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="true"
        :opened="idx === activeIndexCallout"
        @click:open="toggleCallout(idx)"
      >
        <div class="row pl-md-2 mr-md-1 pb-2">
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block border-mobile">Especialista:</span>
            <span class="font-16 color-black">
              {{ item.specialistName }}
            </span>
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block border-mobile">
              {{ serviceLabelText(item) }}:
            </span>
            <span class="font-16 color-black">
              {{ item.discipline.name }}
            </span>
            <span class="data-title d-block border-mobile">
              Número de Contrato:
            </span>
            <span class="font-16 color-black">
              {{ item.contractNumber }}
            </span>
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block border-mobile">
              Nombre de Estudiante:
            </span>
            <span class="font-16 color-black">
              {{ item.studentName }} - {{ item.studentSie }}
            </span>
          </div>
          <div class="col-md-1 col-sm-12">
            <span class="data-title d-block border-mobile">Conteo:</span>
            <span class="font-16 color-black">
              {{ item.recordCount }}
            </span>
          </div>
          <div class="col-md-1 col-sm-12">
            <span class="data-title d-block border-mobile">Costo:</span>
            <span class="font-16">
              {{ formatCurrency(item.costAmount) }}
            </span>
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block border-mobile">
              Tipo de Firma:
            </span>
            <span class="font-16 color-black">
              {{
                item.signatureType
                  ? signatureTypeLabels.Electronic
                  : signatureTypeLabels.Handwritten
              }}
            </span>
          </div>

          <div
            class="
            dropdown
            col-md-2 col-sm-12
            d-flex
            align-items-center
            justify-content-center
          "
          >
            <i
              v-if="showExtraActions"
              class="
              fas
              fa-file-download
              p-2
              mx-2
              border
              rounded
              details-result-row-icon details-icon-green
            "
              @click="() => downloadServiceDocument(item)"
            />
            <i
              v-if="showExtraActions"
              class="
              p-2
              mx-2
              fas
              fa-flag-alt
              border
              rounded
              details-result-row-icon
            "
              :class="
                item.checkedFlag ? 'details-icon-green' : 'details-icon-yellow'
              "
              @click="onCheckUncheckServiceFlagAsIntervined(item)"
            />
            <action-button
              id="dropdownMenuButton"
              aria-expanded="false"
              aria-haspopup="true"
              class="btn"
              :class="
                showExtraActions
                  ? 'mx-2 details-row-extra-actions'
                  : 'btn-dropdown-actions dropdown-toggle'
              "
              data-toggle="dropdown"
              type="button"
              variant="outline-success"
            >
              {{ showExtraActions ? '...' : 'Acciones' }}
            </action-button>
            <div>
              <div
                aria-labelledby="dropdownMenuButton"
                class="dropdown-menu dropdown-menu-right"
              >
                <div
                  class="dropdown-item"
                  @click="
                    openTabAction(idx, contractTabs.INFORMACION_ADICIONAL)
                  "
                >
                  <em class="fas fa-info-circle text-green pr-1 m-md-1" />
                  <span>Información Adicional</span>
                </div>
                <hr class="mt-1 mb-1" />
                <div
                  class="dropdown-item"
                  @click="openTabAction(idx, contractTabs.DOCUMENTO_CONTRATO)"
                >
                  <em class="fas fa-file-alt text-green pr-1 m-md-1 pt-1" />
                  <span>Documento de Contrato</span>
                </div>

                <div
                  class="dropdown-item"
                  @click="openTabAction(idx, contractTabs.DOCUMENTOS)"
                >
                  <em class="fas fa-file-search text-green pr-1 m-md-1 pt-1" />
                  <span>Documentos</span>
                </div>
                <hr class="mt-1 mb-1" />
                <div
                  class="dropdown-item"
                  @click="openTabAction(idx, contractTabs.DETALLES_VISITA)"
                >
                  <em class="fas fa-file-invoice text-green pr-1 m-md-1 pt-1" />
                  <span>Detalles de Visita</span>
                </div>

                <div
                  class="dropdown-item"
                  @click="openTabAction(idx, contractTabs.CERTIFICACION_VISITA)"
                >
                  <em class="fas fa-user-check text-green pr-1 m-md-1 pt-1" />
                  <span>Certificación de Visita</span>
                </div>

                <div
                  v-if="showEvaluationDocumentTab(item)"
                  class="dropdown-item"
                  @click="openTabAction(idx, contractTabs.DOCUMENTO_EVALUACION)"
                >
                  <em class="fas fa-user-check text-green pr-1 m-md-1 pt-1" />
                  <span>Documento de Evaluación</span>
                </div>
                <div
                  v-if="showEditVisits(item)"
                  class="dropdown-item"
                  @click="goToVisitRegistry(item)"
                >
                  <em class="fas fa-file-edit text-green pr-1 m-md-1 pt-1" />
                  <span>Editar Visitas</span>
                </div>

                <div
                  v-if="showAdjustTab"
                  class="dropdown-item"
                  @click="handleOpenAdjustTab(idx)"
                >
                  <em class="fas fa-file-alt text-green pr-1 m-md-1 pt-1" />
                  <span>Ajustar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #edition>
          <div class="p-2">
            <div class="bg-white p-2">
              <custom-tab class="size-tabs" :no-nav-style="true">
                <custom-tab-item
                  :active="
                    currentTabIndex === contractTabs.INFORMACION_ADICIONAL
                  "
                  class="mt-3"
                  lazy
                  title="Información Adicional"
                >
                  <AditionalInformation :data="item" />
                </custom-tab-item>
                <custom-tab-item
                  v-if="showDocumentsTab(item)"
                  :active="currentTabIndex === contractTabs.DOCUMENTO_CONTRATO"
                  class="mt-3"
                  lazy
                  title="Documento de Contrato"
                >
                  <document-contract :data="item" />
                </custom-tab-item>
                <custom-tab-item
                  v-if="showDocumentsTab(item)"
                  :active="currentTabIndex === contractTabs.DOCUMENTOS"
                  class="mt-3"
                  lazy
                  title="Documentos"
                >
                  <Documents :bill-model="bill" :contract="item" />
                </custom-tab-item>
                <custom-tab-item
                  v-if="showVisitDetailTab(item)"
                  :active="currentTabIndex === contractTabs.DETALLES_VISITA"
                  class="mt-3"
                  lazy
                  title="Detalles de Visita"
                >
                  <visit-detail :item="item" />
                </custom-tab-item>

                <custom-tab-item
                  :active="
                    currentTabIndex === contractTabs.CERTIFICACION_VISITA
                  "
                  class="mt-3"
                  lazy
                  title="Certificación de Visita"
                >
                  <VisitCertification
                    :input="item"
                    :read-only="showReadOnlyVisitCertification"
                    @on-cancel="closeTabAction(idx)"
                    @on-save="closeTabAction(idx)"
                  />
                </custom-tab-item>

                <custom-tab-item
                  v-if="showEvaluationDocumentTab(item)"
                  :active="
                    currentTabIndex === contractTabs.DOCUMENTO_EVALUACION
                  "
                  class="mt-3"
                  lazy
                  title="Documento de Evaluación"
                >
                  <contract-evaluation-documents
                    :data="contractEvaluationData(item)"
                    :is-read-only="true"
                  />
                </custom-tab-item>

                <custom-tab-item
                  v-if="showAdjustTab"
                  :active="currentTabIndex === contractTabs.AJUSTES"
                  class="mt-3"
                  lazy
                  title="Ajustes"
                >
                  <Adjustment
                    :ref="`adjustment-tab-ref-${idx}`"
                    :bill="bill"
                    :data="item"
                    :select-adjustment-recommendation-tab="
                      selectAdjustmentRecommendationTab
                    "
                    @on-cancel-adjustment="closeTabAction(idx)"
                  />
                </custom-tab-item>
              </custom-tab>
            </div>
          </div>
        </template>
      </custom-callout>
      <div
        v-if="item.hasAIAdjustmentRecommendations && showAdjustTab"
        class="alert p-3 mb-3 py-2 ai-recommendation-box"
      >
        <div class="d-flex align-items-center">
          <em class="fa fa-bell-exclamation font-20 color-secondary-21 ml-n1" />
          <div class="font-16 font-weight-bold color-secondary-21 ml-3">
            Este resultado cuenta con recomendaciones de ajustes al costo de
            servicios ofrecidos.
            <span
              class="color-secondary-22 cursor-pointer ml-1"
              @click="handleViewRecommendation(idx)"
            >
              <span class="ai-recommendation-box__action-label">
                Ver Recomendación
              </span>
              <em
                class="fa fa-arrow-circle-right font-18 pl-1 pt-n1 ai-recommendation-box__arrow"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import AditionalInformation from './AdditionalInformation.vue';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import VisitDetail from './VisitDetail';
import VisitCertification from './VisitCertification';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import DocumentContract from './DocumentContract.vue';
import Documents from './Documents.vue';
import Adjustment from './Adjustment.vue';
import ContractEvaluationDocuments from '@/views/uspqrp/contract-management/components/tabs/ContractEvaluationDocuments.vue';
import billingStatus from '@/utils/constants/billingStatus';
import utils from '@/utils/utilities';
import tableToCheckFlag from '@/utils/constants/tableToCheckFlag';
import { signatureTypeLabels } from '@/utils/constants/signatureTypes';

import {
  getContractServiceDocument,
  checkUncheckServiceFlagAsIntervined as _checkUncheckServiceFlagAsIntervined,
} from '@/services/provider/billing-contract.api';

const CONTRACT_TABS = {
  INFORMACION_ADICIONAL: 0,
  DETALLES_VISITA: 1,
  DOCUMENTOS: 2,
  CERTIFICACION_VISITA: 3,
  DOCUMENTO_CONTRATO: 4,
  AJUSTES: 5,
  DOCUMENTO_EVALUACION: 6,
};

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
    CustomTab,
    CustomTabItem,
    DocumentContract,
    Documents,
    AditionalInformation,
    VisitDetail,
    Adjustment,
    VisitCertification,
    ContractEvaluationDocuments,
  },
  props: {
    bill: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    showExtraActions: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      currentTabIndex: 0,
      activeIndexCallout: null,
      signatureTypeLabels,
      selectAdjustmentRecommendationTab: false,
    };
  },
  watch: {
    data: {
      handler() {
        for (var ref in this.$refs) {
          if (this.$refs[ref][0].isOpen == true) {
            this.$refs[ref][0].isOpen = false;
          }
        }
        this.activeIndexCallout = null;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    contractTabs() {
      return CONTRACT_TABS;
    },
    showVisitDetailTab() {
      return ({ serviceTypeId }) =>
        serviceTypeId == servicesTypes.Therapy ||
        serviceTypeId == servicesTypes.Assistant ||
        serviceTypeId == servicesTypes.Nurse;
    },
    showDocumentsTab() {
      return ({ serviceTypeId }) =>
        serviceTypeId == servicesTypes.Therapy ||
        serviceTypeId == servicesTypes.Assistant ||
        serviceTypeId == servicesTypes.Nurse ||
        serviceTypeId == servicesTypes.Evaluation;
    },
    showReadOnlyVisitCertification() {
      return this.bill.statusId != billingStatus.Preliminar;
    },
    isTherapyService() {
      return ({ serviceTypeId }) => serviceTypeId === servicesTypes.Therapy;
    },
    isAssistantService() {
      return ({ serviceTypeId }) => serviceTypeId === servicesTypes.Assistant;
    },
    showEditVisits() {
      return (item) =>
        (this.isTherapyService(item) || this.isAssistantService(item)) &&
        this.bill.statusId === billingStatus.Preliminar;
    },
    showAdjustTab() {
      var inStatusToShow = [
        billingStatus.EnProcesoIntervencion,
        billingStatus.PendienteIntervencion,
        billingStatus.EnProcesoDeAjuste,
      ];
      return (
        inStatusToShow.includes(this.bill.statusId) &&
        this.canViewTabAdjustments
      );
    },
    showEvaluationDocumentTab() {
      return (item) => this.isEvaluationServiceType(item);
    },
    isEvaluationServiceType() {
      return (item) => item.serviceTypeId === servicesTypes.Evaluation;
    },
    canViewTabAdjustments() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.viewadjustmentstab'
      );
    },
  },
  methods: {
    getColor(data) {
      let color = null;

      if (data.hasAdjustment) color = '#b354c4';

      return color;
    },
    contractEvaluationData(item) {
      return {
        contractId: item.contractId,
        disciplineTypeId: item.disciplineId,
        studentSieId: item.studentSie,
      };
    },
    toggleCallout(index) {
      this.activeIndexCallout =
        this.activeIndexCallout === index ? null : index;

      this.currentTabIndex = CONTRACT_TABS.INFORMACION_ADICIONAL;
    },
    closeTabAction(index) {
      this.$refs['detail-ref-' + index][0].isOpen = false; // why no close :'(
      this.currentTabIndex = -1;
      this.selectAdjustmentRecommendationTab = false;
    },
    openTabAction(index, tab = 0) {
      if (!this.$refs['detail-ref-' + index][0].isOpen) {
        this.$refs['detail-ref-' + index][0].open();
      }
      this.currentTabIndex = tab;
    },
    serviceLabelText(item) {
      let text = item.serviceType.name;

      switch (item.serviceType.id) {
        case 4:
        case 8:
          // Change label text for assistant and nurse services
          text = 'Asistente';
          break;
      }

      return text;
    },
    async downloadServiceDocument(item) {
      return await getContractServiceDocument(
        item.contractId,
        item.serviceTypeId,
        item.visitSummaryId
      )
        .then((resp) => {
          if (resp.data) {
            return utils.convertToBlob(resp.data);
          } else {
            this.ShowToast('Alerta', 'No se encontró documento.', 'error');
          }
        })
        .catch((err) => {
          let message = err.response?.data?.message;
          message = message == undefined ? 'No existe el documento' : message;
          this.ShowToast('', message, 'error');
        });
    },
    async onCheckUncheckServiceFlagAsIntervined(item) {
      item.checkedFlag = !item.checkedFlag;

      const payload = {
        visitSummaryId: item.visitSummaryId,
        tableToCheckFlag: tableToCheckFlag.RpVisitSummary,
        checked: item.checkedFlag,
      };

      await _checkUncheckServiceFlagAsIntervined(payload).catch((err) =>
        this.ShowToast('', err.response?.data?.message, 'error')
      );
    },
    goToVisitRegistry({ companyId, requestServiceId, contractId }) {
      this.$root.$emit('on-push-visit-registry');
      this.$router.push({
        name: 'visitRegistry',
        params: {
          companyId,
          requestServiceId,
          contractId,
          academicYearId: this.bill.academicYearId,
          disableNavigation: true.toString(),
          month: this.bill.monthNumber,
        },
      });
    },
    async handleOpenAdjustTab(index) {
      this.selectAdjustmentRecommendationTab = false;
      this.openTabAction(index, this.contractTabs.AJUSTES);
    },
    async handleViewRecommendation(index) {
      this.selectAdjustmentRecommendationTab = true;
      this.openTabAction(index, this.contractTabs.AJUSTES);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.container-child {
  border-radius: 5px;
}

.dropdown-item {
  cursor: pointer;
}

.details-icon-green {
  color: var(--green);
  border-color: var(--green) !important;
}

.details-icon-yellow {
  color: var(--yellow);
  border-color: var(--yellow) !important;
}

.details-result-row-icon {
  cursor: pointer;
  font-size: 24px;
  &:hover {
    color: var(--white);
    background-color: var(--green);
  }
}

.details-row-extra-actions {
  font-size: 26px;
  padding: 1px 12px 1px 12px;
  background-color: inherit !important;
  &:hover {
    color: var(--white);
    background-color: var(--green) !important;
  }
}
.size-tabs {
  --tab-font-size: 16px !important;
}

.ai-recommendation-box {
  border-radius: 0px 0px 4px 4px;
  border: 1px solid map-get($colors, 'yellow-1');
  background: linear-gradient(
      0deg,
      rgba(243, 175, 84, 0.2) 0%,
      rgba(243, 175, 84, 0.2) 100%
    ),
    map-get($colors, 'white');

  &__action-label {
    border-bottom: 1px solid;
    padding-bottom: 1px;
    padding-right: 5px;
    user-select: none;
  }
  &__arrow {
    position: absolute;
    margin-top: 5px;
    margin-left: 1px;
  }
}

::v-deep .has-adjustment .fa-chevron-circle-right {
  color: #b354c4 !important;
}

::v-deep .has-adjustment .fa-chevron-circle-down {
  color: #b354c4 !important;
}
</style>
